import ToastCss from './index.module.scss';
type TGToastProp = {
  content: string
}
const GToast = (props: TGToastProp) => {
  const { content } = props;
  return <div className={ToastCss['global-toast-view']}>{content}</div>;
};

export default GToast;
